import { ActionType, getType } from 'typesafe-actions'

import * as actions from './actions'
import { IPlansState, createInitialPlansState } from './types'
import { IPlan } from '../../types/plan'
import { IEntityHashMap } from 'flux-entities'

type TAction = ActionType<typeof actions>

const initialPlansState = createInitialPlansState()

const plansReducer = (state = initialPlansState, action: TAction): IPlansState => {
  switch (action.type) {
    case getType(actions.plansError): {
      return {
        ...state,
        errors: action.payload,
        touched: true,
        loading: false,
      }
    }

    case getType(actions.plansRequest): {
      return {
        ...state,
        touched: true,
        loading: true,
      }
    }

    case getType(actions.plansSuccess): {
      const all: {[id: number]: IPlan} = {}
      const ids: number[] = []

      for (const plan of action.payload) {
        if (!all[plan.id]) {
          ids.push(plan.id)
          all[plan.id] = plan
        }
      }

      return {
        all,
        ids,
        touched: true,
        loading: false,
        errors: []
      }
    }

    case getType(actions.planCreateError): {
      return {
        ...state,
        errors: action.payload,
        touched: true,
        loading: false,
      }
    }

    case getType(actions.planCreateRequest): {
      return {
        ...state,
        touched: true,
        loading: true,
      }
    }

    case getType(actions.planCreateSuccess): {
      return {
        ids: Array.from(new Set([...state.ids, action.payload.id])),
        all: {
          ...state.all,
          [action.payload.id]: action.payload,
        },
        touched: true,
        loading: false,
        errors: []
      }
    }

    case getType(actions.planUpdateError): {
      return {
        ...state,
        errors: action.payload,
        touched: true,
        loading: false,
      }
    }

    case getType(actions.planUpdateRequest): {
      return {
        ...state,
        touched: true,
        loading: true,
      }
    }

    case getType(actions.planUpdateSuccess): {
      return {
        ...state,
        all: {
          ...state.all,
          [action.payload.id]: action.payload,
        },
        touched: true,
        loading: false,
        errors: []
      }
    }

    case getType(actions.planDeleteError): {
      return {
        ...state,
        loading: false,
        errors: action.payload
      }
    }

    case getType(actions.planDeleteRequest): {
      return {
        ...state,
        touched: true,
        loading: true,
      }
    }

    case getType(actions.planDeleteSuccess): {
      const ids = state.ids.filter(x => x !== action.payload.id)
      const updatedState: IEntityHashMap<IPlan> = { ...state.all }
      delete updatedState[action.payload.id]

      return {
        ids,
        all: updatedState,
        touched: true,
        loading: false,
        errors: []
      }
    }
  }

  return state
}

export {
  plansReducer,
  initialPlansState
}
